import React, { useState, useEffect } from 'react'
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles'
import {
  Box,
  Toolbar,
  AppBar,
  Container,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Select,
  Menu,
  MenuItem,
  fade,
} from '@material-ui/core'
// import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Route, Switch, useHistory, useRouteMatch, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import HomeTabs from 'src/components/HomeTabs'
import { MOBILE_HEADER_HEIGHT } from 'src/utils/constant'
import { authRoutes, userRoutes } from 'src/routers/routesConfig'
import { ReactComponent as IconDownArrow } from 'src/assets/icons/icon_down_arrow.svg'
import SignOutButton from 'src/components/dialogButton/SignOutButton'
import BookingTips from 'src/components/BookingTips'
import { useImageTranslation } from 'src/hooks'
import { ReactComponent as HomeIcon } from 'src/mobile/assets/icons/home.svg'
import { ReactComponent as CalendarFillIcon } from 'src/mobile/assets/icons/medical_services.svg'
import { ReactComponent as Promotion } from 'src/mobile/assets/icons/auto_awesome.svg'
import { ReactComponent as FaqIcon } from 'src/mobile/assets/icons/faq.svg'
import { ReactComponent as RightArrowIcon } from 'src/mobile/assets/icons/arrow-ios-right.svg'
import { ReactComponent as FooterIcon8 } from 'src/mobile/assets/icons/footer_icon8.svg'
import { ReactComponent as LanguageIcon } from 'src/mobile/assets/icons/footer_icon7.svg'
import { LANGUAGE_LIST } from 'src/i18n'
// import EDialog from 'src/mobile/themes/components/EDialog'
import { SERVICE_PHONE, SERVICE_EMAIL, SERVICE_WHATSAPP, SITE_MATE_DATA } from '../utils/constant'
import CallOutlinedIcon from '@material-ui/icons/CallOutlined'
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined'
import { ReactComponent as footerIcon3 } from 'src/mobile/assets/icons/wtap.svg'
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import { setLanguage, signOut } from 'src/store/slices/authSlice'
import { ReactComponent as Appointment } from 'src/mobile/assets/icons/order_my.svg'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'
import { ReactComponent as MyProfile } from 'src/mobile/assets/icons/myprofile.svg'

import { changePathName } from 'src/utils/replaceURLs'
// import Accordion from '@material-ui/core/Accordion'
// import AccordionSummary from '@material-ui/core/AccordionSummary'
// import AccordionDetails from '@material-ui/core/AccordionDetails'
import { buttonClick } from 'src/utils/trackingCode'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.palette.background.paper,
      boxShadow: 'none',
      // height: theme.spacing(HEADER_HEIGHT),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      boxSizing: 'content-box',
      border: ' 1px solid #E5E7EB',
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(0),
        height: theme.spacing(MOBILE_HEADER_HEIGHT),
      },
      '& .MuiButton-root': {
        fontWeight: 600,
        color: '#111827',
        fontSize: 16,
      },
    },
    rightButton: {
      // marginLeft: 'auto',
      display: 'flex',
      whiteSpace: 'nowrap',
    },
    logo: {
      display: 'block',
      width: 113,
      marginRight: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.down('sm')]: {
        width: 85.5,
      },
    },
    menu: {
      borderTop: '1px solid #E5E7EB',
    },
    iconColor: {
      color: theme.palette.primary.light,
    },
    headerContent: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      height: theme.spacing(8),
      position: 'relative',
      justifyContent: 'flex-end',
    },
    space: {
      marginRight: theme.spacing(2),
    },
    divider: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: theme.palette.divider,
    },
    profile: {
      borderRadius: 50,
      whiteSpace: 'nowrap',
      backgroundColor: theme.palette.primary.contrastText,
      marginLeft: '28px',
      '&:hover': {
        color: theme.palette.primary.contrastText,
        // backgroundColor: theme.palette.primary.main,
      },
    },
    endDownArrow: {
      '& path': {
        stroke: theme.palette.primary.contrastText,
      },
    },
    link: {
      height: '56px',
      width: '120px',
      cursor: 'pointer',
      lineHeight: 2,
      padding: theme.spacing(0.75, 3),
      marginLeft: theme.spacing(4),
      borderRadius: theme.spacing(1),
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: theme.typography.fontWeightBold,
      },
      [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(1),
        padding: theme.spacing(0.5, 2),
        // fontSize: theme.typography.caption.fontSize,
      },
    },
    menuLink: {
      color: theme.palette.primary.main,
    },
    userNameButton: {
      minWidth: theme.spacing(12.5),
      maxWidth: theme.spacing(14.5),
      fontSize: theme.typography.body2.fontSize,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    menuButton: {
      fontWeight: 600,
      '& .MuiButton-root': {
        fontWeight: 600,
        backgroundColor: 'red',
      },
    },
    languageWrapper: {
      marginLeft: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(1),
      },
    },
    listWrapper: {
      borderStartEndRadius: 12,
      borderStartStartRadius: 12,
      background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${
        theme.palette.background.paper
      } 30%, ${fade(theme.palette.background.paper, 0)} 100%)`,
      padding: theme.spacing(2, 3),
    },
    listItemIcon: {
      minWidth: 'auto',
      marginRight: theme.spacing(1),
    },
    listItem: {
      cursor: 'pointer',
      padding: theme.spacing(1.5, 0),
      marginBottom: theme.spacing(1.5),
    },
    listItemText: {
      cursor: 'pointer',
      fontSize: theme.spacing(2),
      fontWeight: 600,
    },
    languageListItemText: {
      display: 'flex',
      alignItems: 'center',
    },
    selectListItemText: {
      flexGrow: 1,
    },
    arrowIcon: {
      '& path': {
        fill: theme.palette.primary.main,
      },
    },
    logoutButton: {
      height: theme.spacing(7),
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[100]}`,
      color: theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(3),
      '&:hover': {
        backgroundColor: fade(theme.palette.background.paper, 0.8),
      },
    },
    profileBackground: {
      position: 'absolute',
      left: 0,
      width: '100%',
      bottom: 0,
      zIndex: 0,
      opacity: 0.7,
    },
    icon8: {
      '& path': {
        fill: theme.palette.primary.main,
      },
    },
    list: {
      cursor: 'pointer',
      '&:last-child': {
        fontWeight: 500,
      },
    },
    icons: {
      fontSize: 20,
      '& path': {
        fill: theme.palette.grey[400],
      },
    },
    menuItem: {
      paddingRight: theme.spacing(8),
    },
    menuItemIcon: {
      marginRight: theme.spacing(1),
    },
    menuButtonIcon: {
      color: theme.palette.secondary.main,
      '& path': {
        fill: theme.palette.secondary.main,
      },
      marginRight: theme.spacing(1),
      width: 20,
      height: 20,
    },
    accordionSummary: {
      padding: 0,
    },
    accordionDetails: {
      flexDirection: 'column',
    },
    expandIcon: {
      transform: 'rotate(90deg)',
      '&.Mui-expanded': {
        transform: 'rotate(270deg)',
      },
    },
    signup: {
      '& .MuiButton-label': {
        color: theme.palette.primary.contrastText,
      },
    },
    hoverstyle: {
      cursor: 'pointer',
    },
  }),
)
// const Accordion2 = withStyles((theme) => ({
//   root: {
//     backgroundColor: 'transparent',
//     boxShadow: 'none',
//     width: '100%',
//     height: 'auto !important',
//     '&.Mui-expanded': {
//       margin: 0,
//     },
//     '&.Mui-disabled': {
//       backgroundColor: 'transparent',
//       color: theme.palette.primary.contrastText,
//     },
//     '&:before': {
//       display: 'none',
//     },
//   },
//   collapseIcon: {
//     display: 'flex',
//     justifyContent: 'space-between',
//   },
// }))(Accordion)
const Header = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const { pathname } = useLocation()
  const { t, i18n } = useTranslation()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('xs'))
  const isTable = useMediaQuery(theme.breakpoints.down('sm'))
  const { userInfo } = useSelector((state) => state.auth)
  const [anchorEl, setAnchorEl] = useState(null)
  const [tImage] = useImageTranslation()
  const [open, setOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const SignIn = useRouteMatch('/signin')
  const SignUp = useRouteMatch('/signup')

  // const HeaderLine = (params) => {
  //   return <Divider className={classes.divider} />
  // }
  const MENU_LIST = [
    {
      label: 'glossary.personal_info',
      icon: PersonOutlineOutlinedIcon,
      path: '/profile/account',
    },
    {
      label: 'profile.my_appointment',
      icon: Appointment,
      path: '/profile/order',
    },
    // {
    //   label: 'profile.my_report',
    //   icon: Report,
    // },
    // {
    //   label: 'profile.redeem_gifts',
    //   icon: Gifts,
    // },
    // {
    //   label: 'profile.give_advice',
    //   icon: Advice,
    // },
  ]
  // const [activeMenuItem, setActiveMenuItem] = useState(MENU_LIST[0])
  const PROFILE_LIST = [
    {
      label: t('glossary.homepage'),
      path: '/',
      icon: HomeIcon,
      auth: true,
    },
    {
      label: t('common.product_list'),
      path: '/productList',
      icon: CalendarFillIcon,
      auth: true,
    },
    {
      label: t('common.promotion_menu'),
      path: '/promotion',
      icon: Promotion,
    },
    {
      label: t('glossary.faq'),
      path: '/faq',
      icon: FaqIcon,
    },
  ]
  const FooterText = [
    {
      label: t('glossary.contact_us'),
      FooterText: [
        {
          label: SERVICE_PHONE,
          icon: CallOutlinedIcon,
          toTel: true,
          number: '+85236130533',
        },
        {
          label: SERVICE_WHATSAPP,
          icon: footerIcon3,
          toWhatsApp: true,
          number:
            i18n.language === 'zh-HK'
              ? SITE_MATE_DATA.WHATSAPP_PC_HK
              : i18n.language === 'en'
              ? SITE_MATE_DATA.WHATSAPP_PC_EN
              : SITE_MATE_DATA.WHATSAPP_PC_CN,
        },
        {
          label: SERVICE_EMAIL,
          icon: EmailOutlinedIcon,
          toMail: true,
        },
      ],
    },
  ]
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (item, index) => {
    setAnchorEl(null)
    if (item) {
      // setActiveMenuItem(item)
      history.push(`/${i18n.language}${item.path}`)
    }
  }
  const handleClickMenu = () => setMenuOpen(true)
  const handleClickEDrawerMenu = () => setOpen(true)

  const handleSignOut = () => {
    dispatch(signOut())
    history.push(`/${i18n.language}`)
  }
  const handleChangeLanguage = async (e) => {
    const language = e.target.value
    language && i18n.changeLanguage(language)
    if (userInfo && userInfo?.id)
      await dispatch(setLanguage({ id: userInfo?.id, language: language })).unwrap()
    changePathName(language, history, pathname)
  }
  useEffect(() => {
    setAnchorEl(null)
  }, [userInfo])

  const handleSignIn = (params) => history.push(`/${i18n.language}/signin`)
  const handleSignUp = (params) => history.push(`/${i18n.language}/signup`)

  const handleGoBack = () => {
    history.goBack()
  }

  return (
    <AppBar className={classes.root} position="fixed" color="primary">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Switch>
            {userRoutes.map((route) => (
              <Route
                exact={route.exact === false ? route.exact : true}
                path={route.path}
                component={() =>
                  route.title && matches ? (
                    <>
                      <IconButton color="primary" aria-label="back" size="small" onClick={handleGoBack}>
                        <ArrowBackIosIcon fontSize="small" />
                      </IconButton>
                      <Box color="primary.main" mr={1}>
                        {t(route.title)}
                      </Box>
                      {route.path === `/${i18n.language}/profile/order` && <BookingTips />}
                    </>
                  ) : (
                    <Link to={`/${i18n.language}`}>
                      <img className={classes.logo} src={tImage('logo', 'png')} alt="logo" />
                    </Link>
                  )
                }
                key={route.path}
              />
            ))}
            <Route
              path="*"
              component={() => (
                <Link to={`/${i18n.language}`}>
                  <img className={classes.logo} src={tImage('logo', 'png')} alt="logo" />
                </Link>
              )}
            />
          </Switch>
          <div className={classes.headerContent}>
            <HomeTabs />

            <Switch>
              {authRoutes.map((route) => (
                <Route
                  exact={route.exact === false ? route.exact : true}
                  path={route.path}
                  component={null}
                  key={route.path}
                />
              ))}
              {/* <Route path="*" component={HeaderLine} /> */}
            </Switch>

            <Typography className={classnames(classes.rightButton, 'uppercase')} component="div">
              {userInfo ? (
                <>
                  <Button
                    className={classes.profile}
                    variant="outlined"
                    // color="primary"
                    size={isTable ? 'small' : 'medium'}
                    onClick={handleClick}
                    endIcon={<IconDownArrow className={classes.endDownArrow} />}
                  >
                    <Box className={classes.userNameButton}>
                      <Button
                        id="basic-button"
                        // variant="outlined"
                        aria-controls={menuOpen ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={menuOpen ? 'true' : undefined}
                        onClick={handleClickMenu}
                        className={classes.menuButton}
                      >
                        <PersonOutlineOutlinedIcon /> {t('common.my_account')}
                      </Button>
                    </Box>
                  </Button>

                  <Menu
                    id="profile-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => {
                      setAnchorEl(null)
                    }}
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    {MENU_LIST.map((item, index) => (
                      <MenuItem
                        key={item.label}
                        onClick={() => {
                          const buttonName =
                            item.path === '/profile/account'
                              ? 'EH_MyAccount_PersonalDetails_Tab'
                              : 'EH_MyAccount_MyBooking_Tab'
                          buttonClick(buttonName, buttonName)
                          handleClose(item, index)
                        }}
                        className={classes.menuItem}
                      >
                        <item.icon className={classes.menuItemIcon} />
                        {t(item.label)}
                      </MenuItem>
                    ))}
                    <SignOutButton onConfirm={handleSignOut} className={classes.menu}>
                      {t('are_you_sure.common', { action: '$t(common.sign_out)' })}
                    </SignOutButton>
                  </Menu>
                </>
              ) : (
                <Switch>
                  {authRoutes.map((route) => (
                    <Route
                      exact={route.exact === false ? route.exact : true}
                      path={route.path}
                      component={() => (
                        <>
                          <Button
                            variant={SignIn ? 'contained' : 'outlined'}
                            color={SignIn ? 'secondary' : ''}
                            className={classnames(classes.link)}
                            onClick={handleSignIn}
                            fontSize="body1.fontSize"
                            component="span"
                            display="inline-block"
                            style={{
                              margin: 0,
                              marginLeft: 40,
                            }}
                          >
                            {t('common.sign_in')}
                          </Button>
                          <Button
                            variant={SignUp ? 'contained' : 'outlined'}
                            color={SignUp ? 'secondary' : '#FFFFFF'}
                            className={classnames(classes.link)}
                            onClick={handleSignUp}
                            fontSize="body1.fontSize"
                            component="span"
                            display="inline-block"
                          >
                            {t('common.signUp')}
                          </Button>
                        </>
                      )}
                      key={route.path}
                    />
                  ))}
                  <Route
                    path="*"
                    component={() => (
                      <>
                        <Button
                          variant="outlined"
                          className={classnames(classes.link)}
                          onClick={handleSignIn}
                          fontSize="body1.fontSize"
                          component="span"
                          display="inline-block"
                          style={{
                            margin: 0,
                            marginLeft: 40,
                          }}
                        >
                          {t('common.sign_in')}
                        </Button>
                        <Button
                          variant="contained"
                          className={classnames(classes.link, classes.signup)}
                          onClick={handleSignUp}
                          fontSize="body1.fontSize"
                          component="span"
                          display="inline-block"
                          color="secondary"
                        >
                          {t('common.signUp')}
                        </Button>
                      </>
                    )}
                  />
                </Switch>
              )}{' '}
              <Box component="span" className={classes.languageWrapper}>
                <Box height="100%" px={1.5} alignItems="center" display="flex" className={classes.hoverstyle}>
                  <Box ml="auto" alignItems="center" display="flex" onClick={handleClickEDrawerMenu}>
                    <MenuOutlinedIcon style={{ color: '#1A285D' }} />
                  </Box>
                </Box>
                <EDrawer onClose={() => setOpen(false)} open={open} anchor="right" className="pcWidth">
                  {userInfo ? (
                    <Box display="flex" justifyContent="center" px={3}>
                      <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => setOpen(false)}
                        style={{ height: '56px' }}
                        to={`/${i18n.language}/profile/account`}
                        component={Link}
                      >
                        <MyProfile style={{ marginRight: 2 }} />

                        {t('common.my_account')}
                      </Button>
                    </Box>
                  ) : (
                    <Box display="flex" justifyContent="center" px={3}>
                      <Box width="100%" mr={2}>
                        <Button
                          variant="outlined"
                          fullWidth
                          to={`/${i18n.language}/signin`}
                          component={Link}
                          onClick={() => setOpen(false)}
                          style={{
                            height: '56px',
                          }}
                        >
                          {t('common.sign_in')}
                        </Button>
                      </Box>
                      <Box width="100%">
                        <Button
                          variant="contained"
                          color="secondary"
                          fullWidth
                          to={`/${i18n.language}/signup`}
                          onClick={() => {
                            buttonClick('EH_Menu_Reg', 'EH_Menu_Reg')
                            setOpen(false)
                          }}
                          style={{ height: '56px' }}
                          component={Link}
                        >
                          {t('common.signUp')}
                        </Button>
                      </Box>
                    </Box>
                  )}
                  <Box className={classes.listWrapper}>
                    <List disablePadding>
                      {PROFILE_LIST?.map((item, index) => (
                        <ListItem
                          data-path={item.path}
                          data-auth={item.auth}
                          onClick={() => {
                            history.push(`/${i18n.language}${item.path}`)
                            setOpen(false)
                          }}
                          className={classes.listItem}
                          key={item.label}
                        >
                          <ListItemIcon className={classes.listItemIcon}>
                            <item.icon />
                          </ListItemIcon>
                          {/* <Accordion2 classes={{ round: classes.round }}>
                              <AccordionSummary
                                expandIcon={<RightArrowIcon className={classes.arrowIcon} />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                classes={{
                                  root: classes.accordionSummary,
                                  content: classes.content,
                                  expandIcon: classes.expandIcon,
                                }}
                              >
                                <ListItemIcon className={classes.listItemIcon}>
                                  <item.icon />
                                </ListItemIcon>
                                <Box className={classes.listItemText}>{item.label}</Box>
                              </AccordionSummary>
                              <AccordionDetails
                                classes={{
                                  root: classes.accordionDetails,
                                }}
                              >
                                <Typography>
                                  <Box
                                    fontSize={16}
                                    my={1}
                                    onClick={() => {
                                      history.push(`/${i18n.language}/promotion`)
                                      setOpen(false)
                                    }}
                                  >
                                    {t('glossary.all_promotion')}
                                  </Box>
                                  <Box
                                    fontSize={16}
                                    my={1}
                                    onClick={() => {
                                      history.push(`${i18n.language}/promotion`, { value: '2' })
                                      setOpen(false)
                                    }}
                                  >
                                    {t('glossary.promotion_use_function')}
                                  </Box>
                                </Typography>
                              </AccordionDetails>
                            </Accordion2>
                           */}
                          <ListItemText
                            primary={
                              <Typography className={classes.listItemText} variant="h5" noWrap>
                                {t(item.label)}
                              </Typography>
                            }
                          />{' '}
                          <RightArrowIcon className={classes.arrowIcon} />
                        </ListItem>
                      ))}

                      <Box
                        fontWeight={600}
                        onClick={() => {
                          buttonClick('EH_Menu_CorpSite', 'EH_Menu_CorpSite')
                          window.open('https://take2health.net/')
                        }}
                        borderBottom="1px solid #E5E7EB "
                        pb={1}
                      >
                        <Box display="flex">
                          <Box
                            className={classnames(classes.listItemText, classes.languageListItemText)}
                            mr={1}
                          >
                            {t('glossary.web')}
                          </Box>
                          <FooterIcon8 className={classes.icon8} />
                        </Box>
                      </Box>
                      <Box>
                        {FooterText?.map((item, index) => (
                          <Box key={index} className={classes.list}>
                            <Box display="flex">
                              <Box mt={2} fontWeight={600} fontSize={14} color="grey.400">
                                {item.label}
                              </Box>
                            </Box>
                            <Box>
                              {item?.FooterText?.map((item, index) => (
                                <Box key={index} mt={2.25} display="flex">
                                  <item.icon className={classes.icons} />
                                  <Box
                                    ml={1}
                                    fontSize={14}
                                    color="grey.400"
                                    onClick={() => {
                                      const buttonName = item?.toTel
                                        ? 'EH_Menu_Phone'
                                        : item?.toWhatsApp
                                        ? 'EH_Menu_WhatsApp'
                                        : item?.toMail
                                        ? 'EH_Menu_email'
                                        : ''
                                      const buttonId = item?.toTel
                                        ? 'EH_Menu_Phone'
                                        : item?.toWhatsApp
                                        ? 'EH_Menu_WhatsApp'
                                        : item?.toMail
                                        ? 'EH_Menu_email'
                                        : ''
                                      buttonClick(buttonName, buttonId)
                                      item.openNew
                                        ? window.open(item.url)
                                        : item.toTel
                                        ? (window.location.href = `tel:${item.number}`)
                                        : item.toWhatsApp
                                        ? (window.location.href = item.number)
                                        : (window.location.href = `mailto:${item.label}`)
                                    }}
                                  >
                                    {' '}
                                    {item.label}
                                  </Box>
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                      <ListItem className={classes.listItem}>
                        <ListItemText
                          primary={
                            <Typography
                              className={classnames(classes.listItemText, classes.languageListItemText)}
                              variant="h5"
                              noWrap
                            >
                              <LanguageIcon />
                              &nbsp;&nbsp;
                              <Select
                                className={classnames(classes.listItemText)}
                                classes={{
                                  root: classes.select,
                                }}
                                disableUnderline
                                native
                                defaultValue={i18n.language}
                                onChange={handleChangeLanguage}
                              >
                                {LANGUAGE_LIST.map((language, index) => (
                                  <option key={language.lang + index} value={language.lang}>
                                    {t(language.label)}
                                  </option>
                                ))}
                              </Select>
                            </Typography>
                          }
                        />
                      </ListItem>
                    </List>
                    {/* {userInfo && (
                      <EDialog
                        title={t('are_you_sure.sign_out')}
                        trigger={
                          <Button
                            disableElevation
                            className={classes.logoutButton}
                            fullWidth
                            variant="contained"
                          >
                            {t('common.sign_out')}
                          </Button>
                        }
                        onConfirm={handleSignOut}
                      />
                    )} */}
                  </Box>
                </EDrawer>
              </Box>
            </Typography>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Header
